module.exports = __webpack_public_path__ + "assets/5ea4c194ccc85a9442abc2326ef01cce.png";